import {Modal} from 'components/system/Modal'
import {Page} from 'components/system/Page'
import {Basic} from 'types'
import {View} from './components/View'
import {AppearanceProvider} from './providers/AppearanceProvider'
import {Autocompleter} from './providers/Autocompleter'
import {FoldingProvider} from './providers/FoldingProvider'
import {InputProvider} from './providers/InputProvider'
import {StepDataProvider} from './providers/StepDataProvider/StepDataProvider'
import {VentrataDataProvider} from './providers/VentrataDataProvider'
import {CartItemBuilderAction, StepOrder} from './types'

type Props = {
  onClose: () => void
  initialState: Basic.CartItem
  action: CartItemBuilderAction
  stepOrder: StepOrder
}

export const CartItemBuilder = ({onClose, initialState, action, stepOrder}: Props) => {
  return (
    <Modal className="modal-cart-item-builder !w-full h-dvh d:!max-w-[968px] d:h-[calc(100%-64px)] !rounded-none d:!rounded-2xl d:mx-4">
      <Page className="w-full h-full">
        <AppearanceProvider action={action} stepOrder={stepOrder} onClose={onClose}>
          <InputProvider initialState={initialState}>
            <StepDataProvider>
              <VentrataDataProvider>
                <Autocompleter>
                  <FoldingProvider initialLastPassedStepCode={action === 'editing' ? 'availability' : null}>
                    <View />
                  </FoldingProvider>
                </Autocompleter>
              </VentrataDataProvider>
            </StepDataProvider>
          </InputProvider>
        </AppearanceProvider>
      </Page>
    </Modal>
  )
}
